export default __webpack_public_path__ + "static/media/pm.7cde75c7.png";